import { STORAGE_KEYS } from "./config";
import { session } from "./storage";
import { uuid } from "./uuid";

/**
 * A session lasts exactly one app launch. It lives in sessionStorage, so it
 * survives reloads within the same launch but is discarded when the app closes —
 * every fresh open therefore starts a brand-new session.
 *
 * `isNew` is true exactly once per session — the caller emits `session_started`
 * when it sees it.
 */
export const resolveSession = (): { id: string; isNew: boolean } => {
  const stored = session.get(STORAGE_KEYS.session);
  if (stored) {
    return { id: stored, isNew: false };
  }

  const id = `s_${uuid()}`;
  session.set(STORAGE_KEYS.session, id);
  return { id, isNew: true };
};
